import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CustomTable, Text } from '../../../shared/uiComponents';
import { Users } from '../../../shared/Assets/menuIcons';
import { Loader } from '../../../components/StyledComponents';
import { TableBody } from './tableInfo';
import { AuthorizationStatusInfo, BCBA_AUTHORIZATION_HEADERS } from '../helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getAuthorizationInfoBCBA } from '../../../redux/State/clientSlice/dashboardSlice';
import { MobileViewBCBA } from '../MobileView';

// todo pending approval component should be added here when it is confirmed

const AuthorizationInfo = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const user = useSelector((state) => state.account.user);
	const role = useSelector((state) => state.account.role);
	const loading = useSelector((state) => state.dashboard.loading);
	const authorizations = useSelector((state) => state.dashboard.authorizationBCBA);

	useEffect(() => {
		if (!user.id || !role) return;
		const userId = user.id;
		dispatch(getAuthorizationInfoBCBA(userId));
	}, [user, role, dispatch]);

	if (loading) return <Loader />;

	return authorizations?.length ? (
		<div className="dashboardCard">
			<div className="dashboardHeader">
				<div className="header">
					<div className="headerIcon">
						<Users />
					</div>
					<Text type="h6" font="header" fontWeight="semiBold" title="Authorizations" />
				</div>
				<AuthorizationStatusInfo />
			</div>
			<CustomTable
				headers={BCBA_AUTHORIZATION_HEADERS}
				data={{ query: authorizations }}
				TableBody={TableBody}
				loading={loading}
				hasPagination={false}
			/>
			<MobileViewBCBA data={{ query: authorizations }} />
		</div>
	) : null;
};

export default AuthorizationInfo;
